// extracted by mini-css-extract-plugin
module.exports = {"tooltip-trigger":"tooltip_tooltip-trigger__Q9Q8u","tooltip":"tooltip_tooltip__e7asB"};